<template>
  <div>
    <va-modal
      class="evollu-form"
      :value="showModal"
      id="createFlowModal"
      ref="createFlowModal"
      size="large"
      :showOkay="true"
      :okText="this.$t('iframe.titles.create_flow')"
      :cancelText="$t('leads.back')"
      @cancel="$emit('cancel')"
      @ok="handleSubmit"
      :ok-disabled="!canSubmit"
      :noOutsideDismiss="true">

    <div slot="header" class="d-flex justify--space-between">
      <span :class="{'col-width': isMobile}">
          <span><b style="font-size:22px; margin-bottom: 1rem;" class="mr-2"> {{ this.$t('iframe.titles.create_flow')}}</b></span>
        </span>
    </div>

      <ProjectDetails
        :form-errors="flowErrors"
        :clientOptions="clientOptions"
        v-model="flowForm.data.details"
        :collapsable="true"
      />

      <ProjectStyles
        v-if="flowForm.data.details.client"
        ref="projectStyles"
        :form-errors="flowErrors"
        v-model="flowForm.data.styles"
        :client="flowForm.data.details.client"
        :collapsable="true"
      />

      <Legal
        v-if="flowForm.data.details.client"
        :form-errors="flowErrors"
        v-model="flowForm.data.legal"
        :collapsable="true"
      />

      <PagesConfigurator
        v-if="flowForm.data.details.client"
        ref="pagesConfigurator"
        :form-errors="flowErrors"
        :pages="pages"
        v-model="flowForm.data.pages"
        :client="flowForm.data.details.client"
        :collapsable="true"
      />


    </va-modal>
  </div>

</template>

<script>
import ProjectDetails from "@/components/iframe/project-builder/ProjectDetails";
import ProjectStyles from "@/components/iframe/project-builder/ProjectStyles";
import Legal from "@/components/iframe/project-builder/Legal";
import PagesConfigurator from "@/components/iframe/project-builder/PagesConfigurator";
import {IframeService} from "@/api/IframeService";
import Errors from "@/utils/StandardErrors";

const errorsPrefix = 'iframe.flows.errors.'
export default {
  components: {PagesConfigurator, ProjectStyles, ProjectDetails, Legal},
  props: {
    clientOptions: {
      type: Array,
      required: true,
      default: []
    }
  },
  data() {
    return {
      isSubmiting: false,
      showModal: false,
      flowForm: {
        data: {
          details: {
            name: null,
            client: null,
            url: null,
            hash: null,
            lang: null,
            country: null,
            adjust_volume_text: '',
            adjust_volume_audio: null,
            default_output_source: null,
            override_redirect_url: null,
            auto_scroll_to_begin_of_page: null,
            biosigns_monthly_limit_scans: 0,
            biosigns_use_access_codes: null,
          },
          styles: {
            text_size: 10,
            color_primary: null,
            color_primary_dark_20: null,
            color_primary_dark_40: null,
            color_primary_dark_50: null,
            color_secondary: null,
            color_secondary_light_20: null,
            logos: []
          },
          legal: {
            acceptance_text: null,
            acceptance_text_order: null,
            marketing_text: null,
            marketing_text_order: null,
            to_partner_text: null,
            to_partner_text_order: null,
            terms_text: null,
            terms_url: null,
            consent_intro: null,
          },
          pages: []
        }
      },
      pages:[],
      flowErrors: new Errors()
    }
  },
  async mounted() {
    this.showModal = true
    try {
      const pagesResp = await IframeService.getPages()
      this.pages = pagesResp.data
    } catch (err) {
      //todo handle err
      console.log(err)
    }
  },
  methods: {
    handleSubmit: function() {
      if(Object.keys(this.flowErrors.errors).length > 0) {
        this.showToast(this.$t('iframe.flows.create_error'), this.$store.state.errorToastOptions)
        return
      }
      if(this.canSubmit) {
        this.isSubmiting = true
        let formDataToSubmit = {}

        formDataToSubmit.name = this.flowForm.data.details.name
        if (this.flowForm.data.details.client) {
          formDataToSubmit.client_id = parseInt(this.flowForm.data.details.client.id)
        }
        formDataToSubmit.hash = this.flowForm.data.details.hash
        if(this.flowForm.data.details.country) {
          formDataToSubmit.country = this.flowForm.data.details.country.code
        }
        if (this.flowForm.data.details.lang.lang) {
          formDataToSubmit.lang = this.flowForm.data.details.lang.lang
        }
        if(this.flowForm.data.details.default_output_source) {
          formDataToSubmit.default_output_source = this.flowForm.data.details.default_output_source.source
        }
        formDataToSubmit.adjust_volume_text = this.flowForm.data.details.adjust_volume_text
        formDataToSubmit.text_size = this.flowForm.data.styles.text_size
        formDataToSubmit.colors= {...this.flowForm.data.styles}

        if (this.$refs.projectStyles.selectedLogos.length > 0) {
          formDataToSubmit.logos = this.$refs.projectStyles.selectedLogos.map(logo => parseInt(logo.id))
        }
        if(this.$refs.pagesConfigurator.addedPages.length > 0) {
          formDataToSubmit.pages = this.$refs.pagesConfigurator.addedPages.map(page => parseInt(page.page.id))
        }

        formDataToSubmit.acceptance_text = this.flowForm.data.legal.acceptance_text
        formDataToSubmit.acceptance_text_order = this.flowForm.data.legal.acceptance_text_order
        formDataToSubmit.marketing_text = this.flowForm.data.legal.marketing_text
        formDataToSubmit.marketing_text_order = this.flowForm.data.legal.marketing_text_order
        formDataToSubmit.to_partner_text = this.flowForm.data.legal.to_partner_text
        formDataToSubmit.to_partner_text_order = this.flowForm.data.legal.to_partner_text_order
        formDataToSubmit.terms_text = this.flowForm.data.legal.terms_text
        formDataToSubmit.terms_url = this.flowForm.data.legal.terms_url
        formDataToSubmit.consent_intro = this.flowForm.data.legal.consent_intro
        formDataToSubmit.override_redirect_url = this.flowForm.data.details.override_redirect_url
        formDataToSubmit.auto_scroll_to_begin_of_page = this.flowForm.data.details.auto_scroll_to_begin_of_page
        formDataToSubmit.biosigns_monthly_limit_scans = this.flowForm.data.details.biosigns_monthly_limit_scans

        formDataToSubmit.adjust_volume_audio = this.flowForm.data.details.adjust_volume_audio
        let formData
        if (formDataToSubmit.adjust_volume_audio !== null) {
          formData = new FormData()
          formData.append('sound', formDataToSubmit.adjust_volume_audio)
        } else {
          formData = null
        }

        IframeService.createFlow(formDataToSubmit)
          .then(res => {
            IframeService.updateAdjustVolumeAudio(res.data.id, formData)
              .then(response => {
                this.showToast(this.$t('iframe.flows.create_success'), this.$store.state.successToastOptions)
                this.$emit('created')
                this.showModal = false
              })
              .catch(error => {
                console.log(error)
                if(error.response.status === 422) {
                  this.flowErrors.record(error.response.data.errors, errorsPrefix)
                }
                this.showToast(this.$t('iframe.flows.create_error'), this.$store.state.errorToastOptions)
              })
          })
          .catch(err => {
            console.log(err)
            if(err.response.status === 422) {
              this.flowErrors.record(err.response.data.errors, errorsPrefix)
            }
            this.showModal = true
            this.showToast(this.$t('iframe.flows.create_error'), this.$store.state.errorToastOptions)
          })
          .finally(() => {
            this.isSubmiting = false

          })
      }
    }
  },
  computed: {
    canSubmit() {
      return (this.flowForm.data.details.name !== null && this.flowForm.data.details.name !== '')
        && (this.flowForm.data.details.lang !== null)
        && (this.flowForm.data.details.hash !== null && this.flowForm.data.details.hash !== '')
        && (this.$refs.pagesConfigurator.addedPages.length > 0)
        && !this.isSubmiting
    },
    isMobile: function () {
      return window.matchMedia(`(max-width: 767px)`).matches || window.matchMedia(`(max-height: 400px)`).matches
    },
  },
}
</script>

<style scoped>

</style>
